module.exports = __webpack_public_path__ + "img/Winterstrand.615d52d5.jpg";